<template>
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.40633 0.292893C7.0158 -0.0976311 6.38264 -0.0976311 5.99211 0.292893L0.285005 6L5.99211 11.7071C6.38264 12.0976 7.0158 12.0976 7.40633 11.7071C7.79685 11.3166 7.79685 10.6834 7.40633 10.2929L3.11343 6L7.40633 1.70711C7.79685 1.31658 7.79685 0.683417 7.40633 0.292893Z"
      fill="#868D9C"
    />
  </svg>
</template>
